import { AfterViewInit, Component, ElementRef, Input, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SiteParameter, SiteTwin } from 'src/api/models';
import { FireForesightService } from 'src/api/services';
import { AzureAuthService } from 'src/service/azure-auth.service';

@Component({
  selector: 'fire-image-classifier',
  templateUrl: './fire-image-classifier.component.html',
  styleUrls: ['./fire-image-classifier.component.css']
})
export class FireImageClassifierComponent {
  
  @Input() shown: boolean = false;
  @Input() siteTwin: SiteTwin;
  @Input() selectedImage: SiteParameter;
  @Output() onClosed = new EventEmitter();

  selection: any;
  imageSrc: string;

  constructor(private svc: FireForesightService, public auth: AzureAuthService, public toaster: ToastrService){

  }

  selectonComplete(event){
    this.selection = event;
  }

  createIgnoreZone(){
    console.log("createIgnoreZone()")
    //"{\"objects\":[{\"object\":\"Fire\",\"confidence\":\"0.77790546417236328\",\"rectangle\":{\"x\":1613,\"y\":421,\"w\":146,\"h\":60}}]}"
    var results = {objects:[{object:'Ignore Zone',confidence:this.selection.confidence/100, rectangle:{x: this.selection.x, y: this.selection.y, h: this.selection.height, w: this.selection.width}}]};
    var fieldOfView = this.selectedImage.fieldOfView;
    
    if (fieldOfView == null || fieldOfView == 0){
      fieldOfView = this.siteTwin.metaData["fieldOfView"] ? 
          parseInt(this.siteTwin.metaData["fieldOfView"]) : 
          (360 / Object.values(this.siteTwin.parameters).filter(v => !v.hidden).length);
    }
    this.svc.FireForesightCreateIgnoreZone({
      SiteUri: this.siteTwin.siteUri,
      ImageUrl: this.selectedImage.latestValue.value, // using this as it should be the fixed in time URL
      ImageFeedUri: this.selectedImage.uri,
      FirstDetected: this.selectedImage.latestValue.timeStamp,
      ImageWidth: this.selection.imageWidth,
      ImageHeight: this.selection.imageHeight,
      CameraBearing: this.selectedImage.bearing,
      CameraElevation: this.selectedImage.elevation,
      CameraFieldOfView: fieldOfView,
      Confidence: this.selection.confidence,
      DetectionMetaData: JSON.stringify(results)
    }).subscribe(result => {
      this.onClosed.emit();
    });
  }

  raiseIncident(){
    console.log("raiseIncident()")
    //"{\"objects\":[{\"object\":\"Fire\",\"confidence\":\"0.77790546417236328\",\"rectangle\":{\"x\":1613,\"y\":421,\"w\":146,\"h\":60}}]}"
    var results = {objects:[{object:'Fire',confidence:this.selection.confidence/100, rectangle:{x: this.selection.x, y: this.selection.y, h: this.selection.height, w: this.selection.width}}]};
    var fieldOfView = this.selectedImage.fieldOfView;
    
    if (fieldOfView == null || fieldOfView == 0){
      fieldOfView = this.siteTwin.metaData["fieldOfView"] ? 
          parseInt(this.siteTwin.metaData["fieldOfView"]) : 
          (360 / Object.values(this.siteTwin.parameters).filter(v => !v.hidden).length);
    }
    
    this.svc.FireForesightRaiseManualDetection({
      SiteUri: this.siteTwin.siteUri,
      ImageUrl: this.selectedImage.latestValue.value, // using this as it should be the fixed in time URL
      ImageFeedUri: this.selectedImage.uri,
      FirstDetected: this.selectedImage.latestValue.timeStamp,
      ImageWidth: this.selection.imageWidth,
      ImageHeight: this.selection.imageHeight,
      CameraBearing: this.selectedImage.bearing,
      CameraElevation: this.selectedImage.elevation,
      CameraFieldOfView: fieldOfView,
      DetectionMetaData: JSON.stringify(results)
    }).subscribe(result => {
      this.onClosed.emit();
      if (result == null){
        this.toaster.error("Detection Not Raised")
      }else{
        this.toaster.success("Detection Raised") 
        //result.detectionId
        //todo: redirect to detection
      }
    });
    
  }
}
